import React from "react";
import styles from "./st.module.scss";

import img1 from "./images/img1.png";
import HeaderCompusWithImage from "../../../../Common/HeaderCompusWithImage/HeaderCompusWithImage";
import LeftColoredTitle from "../../../../components/Titles/LeftColoredTitle";

export const PolitiqueRSEHeader = () => {
  return (
    <HeaderCompusWithImage
      images={[img1]}
      title="Politique RSE de l’Université Ibn Khaldoun"
    />
  );
};

function PolitiqueRSE() {
  return (
    <div className={styles.main}>
      <LeftColoredTitle>
        Politique RSE de l’Université Ibn Khaldoun
      </LeftColoredTitle>
      {/* 
      <img
        src={img1}
        alt="Politique assurance qualité de l’UIK"
        className={styles.full_img}
      /> */}

      <h2 className={styles.sub_title}>
        Introduction et engagement de l’établissement
      </h2>

      <p className={styles.description}>
        L’Université Ibn Khaldoun (UIK), en tant qu’établissement d’enseignement
        supérieur privé, s’engage à intégrer les principes de la Responsabilité
        Sociétale des Entreprises (RSE) dans l’ensemble de ses activités. Cet
        engagement découle de notre volonté de contribuer activement au
        développement durable, à l’éthique, à l’inclusion et à la prospérité de
        notre communauté universitaire et de notre environnement
        socio-économique.
      </p>

      <h2 className={styles.sub_title}>Gouvernance responsable</h2>

      <p className={styles.description}>
        L’UIK promeut une gouvernance éthique, transparente et participative. Le
        processus décisionnel associe les parties prenantes internes et externes
        dans un souci de responsabilité, d’intégrité et d’efficience. Une charte
        de gouvernance régit les rôles, devoirs et responsabilités des organes
        de direction.
      </p>

      <h2 className={styles.sub_title}>Respect des droits humains</h2>

      <p className={styles.description}>
        L’université s’engage à respecter et promouvoir les droits humains
        fondamentaux, tels que définis par les textes internationaux. Cela
        inclut le rejet de toute forme de discrimination, de harcèlement, de
        travail forcé ou infantile, et la promotion de l’égalité entre tous les
        individus.
      </p>

      <h2 className={styles.sub_title}>
        Conditions de travail et bien-être des collaborateurs
      </h2>

      <p className={styles.description}>
        L’UIK veille à offrir un environnement de travail sain, sûr et stimulant
        à l’ensemble de ses collaborateurs. Des actions concrètes sont mises en
        place pour favoriser l’équilibre vie professionnelle / vie personnelle,
        le développement des compétences, et la reconnaissance du travail
        accompli.
      </p>

      <h2 className={styles.sub_title}>Engagement environnemental</h2>

      <p className={styles.description}>
        L’Université intègre la préoccupation environnementale dans toutes ses
        décisions et encourage la réduction de son empreinte écologique. Des
        pratiques éco-responsables sont promues : tri des déchets, économies
        d’énergie, dématérialisation des documents, actions de sensibilisation.
      </p>

      <h2 className={styles.sub_title}>Engagement sociétal et territorial</h2>

      <p className={styles.description}>
        L’UIK agit en faveur du développement local par des partenariats, des
        projets d’impact social et la valorisation de l’expertise académique au
        service de la société. Elle favorise le dialogue avec les acteurs de son
        territoire pour mieux répondre à leurs besoins.
      </p>

      <h2 className={styles.sub_title}>Responsabilité envers les étudiants</h2>

      <p className={styles.description}>
        L’université garantit à ses étudiants un cadre d’étude inclusif,
        respectueux et équitable. Elle lutte contre les inégalités d’accès à
        l’éducation, soutient la diversité, et accompagne chaque étudiant vers
        la réussite et l’insertion professionnelle.
      </p>

      <h2 className={styles.sub_title}>
        Éthique, transparence et lutte contre la corruption
      </h2>

      <p className={styles.description}>
        L’UIK s’engage dans une démarche d’intégrité : lutte contre la fraude
        académique, corruption, plagiat, conflits d’intérêt. Un code éthique et
        des procédures de signalement garantissent la transparence dans
        l’ensemble des pratiques universitaires.
      </p>

      <h2 className={styles.sub_title}>Achats responsables</h2>

      <p className={styles.description}>
        Les achats et partenariats de l’université prennent en compte des
        critères sociaux, environnementaux et éthiques. L’UIK privilégie les
        fournisseurs locaux, éthiques et responsables, en cohérence avec ses
        valeurs.
      </p>

      <h2 className={styles.sub_title}>Mise en œuvre, suivi et évaluation</h2>

      <p className={styles.description}>
        Le pilote PAC assure la mise en œuvre de cette politique. Des
        indicateurs de performance permettent de suivre les actions, et des
        audits réguliers assurent l’évaluation et l’amélioration continue. Un
        rapport RSE annuel est publié et partagé avec les parties prenantes.
      </p>

      <h2 className={styles.sub_title}>
        Communication et amélioration continue
      </h2>

      <p className={styles.description}>
        La politique RSE est communiquée à toute la communauté universitaire et
        fait l’objet d’un processus d’amélioration continue. L’université
        encourage le dialogue ouvert avec ses parties prenantes et valorise les
        initiatives innovantes en matière de responsabilité sociétale.
      </p>
    </div>
  );
}

export default PolitiqueRSE;
